export interface IDialogService {
  alert(title: string, message: string): void;

  info(info: string): void;

  message(message: string): void;

  error(message: string): void;

  confirmYesNo(message: string, yesFunction: Function, noFunction: Function): void;

  confirmYesNoCancel(message: string, yesFunction: Function, noFunction: Function): void;
}
